export default "__VITE_ASSET__Cno5kI5M__"